import React from 'react';
import Img from 'gatsby-image';
import './articlecard.scss';
import '../pages/index.scss';
import { Link } from 'gatsby';
import moment from 'moment';

interface Props {
  title: string | JSX.Element;
  body: string;
  articleUrl?: string;
  eventUrl?: string;
  imgURL?: any;
  forEvents?: boolean;
  date?: string;
}

const ArticleCard: React.FC<Props> = ({
  body,
  title,
  imgURL,
  articleUrl,
  forEvents,
  eventUrl,
  date,
}) => {
  const newDate = moment(date).format('MMM Do YYYY');

  if (forEvents) {
    return (
      <Link to={`/events/${eventUrl}`}>
        <div className="eventCardContainer">
          {imgURL && <Img fluid={imgURL} />}
          <div className="eventCardInner">
            <h5>{`${moment(date).format('MMM, DD, YYYY, h:mm A')}`}</h5>
            <h4>{body}</h4>
          </div>
        </div>
      </Link>
    );
  }
  return (
    <Link to={`/blog/${articleUrl}`}>
      <div className="articleCardContainer">
        {imgURL && <Img fluid={imgURL} />}
        <div className="articleCardInner">
          <h4>{title}</h4>
          <p>{body}</p>
          {articleUrl && <h5>{newDate}</h5>}
        </div>
      </div>
    </Link>
  );
};

export default ArticleCard;
